import { Styles, generateClasses } from 'netline-ui';

export const errorDialogClasses = generateClasses('ErrorDialog', [
  'root',
  'title',
  'actions',
  'paper',
  'message',
  'details',
] as const);

const styles: Styles = ({ theme: { spacing } }) => ({
  // TODO: check if dialog paper className works correctly as it is rendered in portal
  [`.${errorDialogClasses.paper}`]: {
    maxWidth: 800,
    minWidth: '50%',

    [`.${errorDialogClasses.message}`]: {
      flex: '0 0 auto',
    },
    [`.${errorDialogClasses.details}`]: {
      marginTop: spacing(2),
      marginBottom: spacing(2),
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
});

export default styles;
